module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"selectCamera":"Выберите камеру"}}')
  delete Component.options._Ctor
}
